import React from "react";
import TrackVisibility from "react-on-screen";
import CountUp from "react-countup";

const AboutTwo = () => {
  return (
    <div className="space-top">
      <div className="container">
        <div className="row">
          {/* Imágenes y contadores */}
          <div className="col-xxl-7 col-xl-6">
            <div className="about-thumb2 mb-40 mb-xl-0">
              <div className="about-img-1">
                {/* Actualiza la ruta de tu imagen */}
                <img
                  src="assets/img/normal/about_2-1.png"
                  alt="Leal Chapa y Pintura"
                />
              </div>
              <div className="about-img-2">
                {/* Actualiza la ruta de tu imagen */}
                <img
                  src="assets/img/normal/about_2-2.png"
                  alt="Leal Chapa y Pintura"
                />
              </div>

              {/* Contador 1 (Clientes satisfechos) */}
              <div className="about-counter-wrap jump-reverse">
                <img
                  src="assets/img/icon/about_icon2-1.svg"
                  alt="Leal Chapa y Pintura"
                />
                <h3 className="about-counter">
                  <TrackVisibility once>
                    {({ isVisible }) =>
                      isVisible && (
                        <span className="counter-number">
                          <CountUp delay={0} start={0} end={5} />
                          k+
                        </span>
                      )
                    }
                  </TrackVisibility>
                </h3>
                <h4 className="about-counter-text">Clientes Satisfechos</h4>
              </div>

              {/* Contador 2 (Años de experiencia) */}
              <div className="about-year-wrap2 movingX">
                <div className="about-year-grid-wrap">
                  <div className="icon">
                    {/* Actualiza la ruta si es necesario */}
                    <img
                      src="assets/img/icon/about_icon2-2.png"
                      alt="Leal Chapa y Pintura"
                    />
                  </div>
                  <h3 className="about-counter">
                    <span className="counter-number">15+</span>+
                  </h3>
                </div>
                <h4 className="about-year-text">Años de Experiencia</h4>
              </div>
            </div>
          </div>

          {/* Texto y secciones de características */}
          <div className="col-xxl-5 col-xl-6">
            <div className="about-content-wrap">
              <div className="title-area mb-30">
                <span className="sub-title">Conoce Sobre Nosotros</span>
                <h2 className="sec-title">
                  Leal Chapa y Pintura
                  <img
                    className="title-bg-shape shape-center"
                    src="assets/img/bg/title-bg-shape.png"
                    alt="Leal Chapa y Pintura"
                  />
                </h2>
                <p className="sec-text">
                  En Leal trabajamos con materiales de primera calidad,
                  ofreciendo garantía de por vida en chapa y pintura. Nuestro
                  equipo cuenta con amplia experiencia y un compromiso total con
                  la satisfacción de nuestros clientes.
                </p>
              </div>

              {/* Característica 1 */}
              <div className="about-feature-wrap style-shadow">
                <div className="icon">
                  <img
                    src="assets/img/icon/about_icon2-3.svg"
                    alt="Leal Chapa y Pintura"
                  />
                </div>
                <div className="about-feature-wrap-details">
                  <h5 className="about-feature-title">
                    Materiales de Alta Calidad
                  </h5>
                  <p className="about-feature-text">
                    Utilizamos pinturas y accesorios de primera, garantizando un
                    acabado impecable y duradero en cada vehículo que
                    atendemos.
                  </p>
                </div>
              </div>

              {/* Característica 2 */}
              <div className="about-feature-wrap style-shadow">
                <div className="icon">
                  <img
                    src="assets/img/icon/about_icon2-4.svg"
                    alt="Leal Chapa y Pintura"
                  />
                </div>
                <div className="about-feature-wrap-details">
                  <h5 className="about-feature-title">Servicio Profesional</h5>
                  <p className="about-feature-text">
                    Nuestro equipo de expertos está capacitado para asesorarte y
                    reparar tu vehículo con la más alta calidad y rapidez.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </div>
  );
};

export default AboutTwo;
